import React, { useState, useEffect } from "react";
import Loader from "../../../loader/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { domain } from "../../../../security";
import { useSelector } from "react-redux";
import { selectUserID } from "../../../../redux/IchthusSlice";

const AddLocations = ({ onClose, refreshData, locationToEdit }) => {
  const currentUserID = useSelector(selectUserID);

  const [formData, setFormData] = useState({
    locationName: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (locationToEdit) {
      setFormData({
        locationName:
          locationToEdit.locationName || locationToEdit.LocationName || "",
      });
    } else {
      setFormData({ locationName: "" });
    }
  }, [locationToEdit]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const apiUrl = `${domain}/api/Locations`;

    // ✅ Inject UserID for audit trail
    const payload = {
      ...formData,
      userID: currentUserID,
    };

    try {
      if (locationToEdit) {
        await axios.put(`${apiUrl}/${locationToEdit.id}`, payload, {
          headers: { "Content-Type": "application/json" },
        });
        toast.success("Location updated successfully");
      } else {
        await axios.post(apiUrl, payload, {
          headers: { "Content-Type": "application/json" },
        });
        toast.success("Location added successfully");
      }
      refreshData();
      onClose();
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        `${locationToEdit ? "Error updating" : "Error adding"} location: ${error.message}`,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6">
      {isLoading && <Loader />}
      <div className="relative w-full">
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 p-2 text-gray-500 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 className="text-2xl mb-6 font-bold text-gray-800">
          {locationToEdit ? "Edit Location" : "Add Location"}
        </h2>

        <form onSubmit={handleFormSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="locationName"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Location Name
            </label>
            <input
              id="locationName"
              type="text"
              required
              placeholder="e.g., Warehouse A, Floor 2, etc."
              className="border border-gray-300 rounded-md py-2 px-3 w-full focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
              value={formData.locationName}
              onChange={handleInputChange}
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-lg shadow transition-colors"
          >
            {locationToEdit ? "Update Location" : "Add Location"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddLocations;
